import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import PieGraph from "../../../general/PieGraph";
import BarGraph from "../../../general/BarGraph";
import styles from "./InfraL3.module.css";

function InfraL3({ distrito }) {
  const [infraestrutura, setInfraestrutura] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [infraestrutura] =
          await Promise.all([
            Api.getInfraestrutura(distrito),
          ]);
        setInfraestrutura(Functions.buildBarGraph(infraestrutura));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);
  const mockupFunction = (value) => {
    value = value + 1;
  };

  return (
    <div className={styles.infraL3}>
      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {infraestrutura && (
            <BarGraph
              data={infraestrutura}
              text="INFRAESTRUTURA"
              onImageReady={mockupFunction}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default InfraL3;
